<template>
    <b-td style="width: 160px">
        <v-select
                :options="options"
                label="icon"
                class="status-style-chooser"
                @input="sendToParent"
                :placeholder=placeholder
                :searchable="false"
        >
            <template v-slot:option="option">
                <span :class="option.icon"></span>
                {{ option[text] }}
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="flex">
                    <div class="col">
                        <span class="fa" :class="option.icon" v-if="option.icon"></span>
                        <span  v-if="!option.icon">    {{ option[text] }}</span>
                    </div>
                </div>
            </template>
        </v-select>
    </b-td>
</template>

<script>
    export default {
        name: 'TableFilterSelect',
        props: {
            options: {
                type: Array,
                required: true
            },
            text: {
                type: String,
                required: true
            },
            val: {
                type: String,
                required: true
            },
            placeholder: String,
            name: String
        },
        data() {
            return {
                value: ''
            };
        },
        methods: {
            sendToParent(e) {
                if (e) {
                    this.value = e[this.val];
                    this.$emit('method', this.name, this.value);
                }else{

                    this.$emit('method', this.name, undefined);
                }
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
